import { render } from "./TabTranscripts.vue?vue&type=template&id=55aa3e5e&scoped=true"
import script from "./TabTranscripts.vue?vue&type=script&lang=js"
export * from "./TabTranscripts.vue?vue&type=script&lang=js"

import "./TabTranscripts.vue?vue&type=style&index=0&id=55aa3e5e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-55aa3e5e"

export default script